var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"text",class:{ noheight: _vm.isShow }},[_c('div',{staticClass:"expand",class:[_vm.isShow ? 'close' : 'open'],on:{"click":function($event){_vm.isShow = !_vm.isShow}}}),_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }